export const colorThemes = {
  vivid: [
    "#ef476f", // accent0-color
    "#ffbc1f", // accent1-color
    "#06d6a0", // accent2-color
    "#118ab2", // accent3-color
    "#073b4c", // accent4-color
    "#45cb3a", // success-color
    "#f3521e"  // failure-color
  ],
  earth: [
    "#314455",
    "#644e5b",
    "#9d5a63",
    "#c96567",
    "#f5b473",
    "#55b14e",
    "#ed5757"
  ],
  clean: [
    "#f6511d",
    "#ffb400",
    "#00a6ed",
    "#7fb800",
    "#a100ed",
    "#16c547",
    "#fe8b37"
  ],
  ocean: [
    "#13293d",
    "#006494",
    "#247ba0",
    "#1b98e0",
    "#44b7dc",
    "#80c078",
    "#ff7a7a"
  ],
  viso: [
    "#2184f9",
    "#845ec2",
    "#d65db1",
    "#ff6f91",
    "#ff9671",
    "#80c07b",
    "#ff7a7a"
  ],
  forrest: [
    "#23d681",
    "#1ba563",
    "#96e072",
    "#4c9522",
    "#29bf12",
    "#01baef",
    "#fe8b37"
  ]
};
